// Auth action types
export const AUTH_LOGIN_REQUEST = 'AUTH_LOGIN_REQUEST';
export const AUTH_LOGIN_SUCCESS = 'AUTH_LOGIN_SUCCESS';
export const AUTH_LOGIN_FAILURE = 'AUTH_LOGIN_FAILURE';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_REGISTER_REQUEST = 'AUTH_REGISTER_REQUEST';
export const AUTH_REGISTER_SUCCESS = 'AUTH_REGISTER_SUCCESS';
export const AUTH_REGISTER_FAILURE = 'AUTH_REGISTER_FAILURE';
export const AUTH_RESET_PASSWORD_REQUEST = 'AUTH_RESET_PASSWORD_REQUEST';
export const AUTH_RESET_PASSWORD_SUCCESS = 'AUTH_RESET_PASSWORD_SUCCESS';
export const AUTH_RESET_PASSWORD_FAILURE = 'AUTH_RESET_PASSWORD_FAILURE';
export const AUTH_REQUEST_LOGIN_OTP_REQUEST = 'AUTH_REQUEST_LOGIN_OTP_REQUEST';
export const AUTH_REQUEST_LOGIN_OTP_SUCCESS = 'AUTH_REQUEST_LOGIN_OTP_SUCCESS';
export const AUTH_REQUEST_LOGIN_OTP_FAILURE = 'AUTH_REQUEST_LOGIN_OTP_FAILURE';
export const AUTH_VERIFY_LOGIN_OTP_REQUEST = 'AUTH_VERIFY_LOGIN_OTP_REQUEST';
export const AUTH_VERIFY_LOGIN_OTP_SUCCESS = 'AUTH_VERIFY_LOGIN_OTP_SUCCESS';
export const AUTH_VERIFY_LOGIN_OTP_FAILURE = 'AUTH_VERIFY_LOGIN_OTP_FAILURE';
export const AUTH_FORGOT_PASSWORD_REQUEST = 'AUTH_FORGOT_PASSWORD_REQUEST';
export const AUTH_FORGOT_PASSWORD_SUCCESS = 'AUTH_FORGOT_PASSWORD_SUCCESS';
export const AUTH_FORGOT_PASSWORD_FAILURE = 'AUTH_FORGOT_PASSWORD_FAILURE';
export const AUTH_VERIFY_PASSWORD_RESET_OTP_REQUEST = 'AUTH_VERIFY_PASSWORD_RESET_OTP_REQUEST';
export const AUTH_VERIFY_PASSWORD_RESET_OTP_SUCCESS = 'AUTH_VERIFY_PASSWORD_RESET_OTP_SUCCESS';
export const AUTH_VERIFY_PASSWORD_RESET_OTP_FAILURE = 'AUTH_VERIFY_PASSWORD_RESET_OTP_FAILURE';
export const AUTH_VERIFY_REGISTRATION_OTP_REQUEST = 'AUTH_VERIFY_REGISTRATION_OTP_REQUEST';
export const AUTH_VERIFY_REGISTRATION_OTP_SUCCESS = 'AUTH_VERIFY_REGISTRATION_OTP_SUCCESS';
export const AUTH_VERIFY_REGISTRATION_OTP_FAILURE = 'AUTH_VERIFY_REGISTRATION_OTP_FAILURE';
export const AUTH_REFRESH_TOKEN = 'AUTH_REFRESH_TOKEN';
export const AUTH_REFRESH_SUCCESS = 'AUTH_REFRESH_SUCCESS';

// Session Expiry
export const SESSION_EXPIRED = 'SESSION_EXPIRED';
export const RESET_SESSION_EXPIRED = 'RESET_SESSION_EXPIRED';

// Device conflict handling
export const AUTH_CHECK_EXISTING_SESSION_REQUEST = 'AUTH_CHECK_EXISTING_SESSION_REQUEST';
export const AUTH_CHECK_EXISTING_SESSION_SUCCESS = 'AUTH_CHECK_EXISTING_SESSION_SUCCESS';
export const AUTH_CHECK_EXISTING_SESSION_FAILURE = 'AUTH_CHECK_EXISTING_SESSION_FAILURE';
export const AUTH_FORCE_LOGOUT_ALL_DEVICES_REQUEST = 'AUTH_FORCE_LOGOUT_ALL_DEVICES_REQUEST';
export const AUTH_FORCE_LOGOUT_ALL_DEVICES_SUCCESS = 'AUTH_FORCE_LOGOUT_ALL_DEVICES_SUCCESS';
export const AUTH_FORCE_LOGOUT_ALL_DEVICES_FAILURE = 'AUTH_FORCE_LOGOUT_ALL_DEVICES_FAILURE';

// Multi-device limit (5 devices)
export const AUTH_DEVICE_LIMIT_REACHED = 'AUTH_DEVICE_LIMIT_REACHED';
export const AUTH_LOGOUT_SPECIFIC_DEVICES_REQUEST = 'AUTH_LOGOUT_SPECIFIC_DEVICES_REQUEST';
export const AUTH_LOGOUT_SPECIFIC_DEVICES_SUCCESS = 'AUTH_LOGOUT_SPECIFIC_DEVICES_SUCCESS';
export const AUTH_LOGOUT_SPECIFIC_DEVICES_FAILURE = 'AUTH_LOGOUT_SPECIFIC_DEVICES_FAILURE';
export const AUTH_CLEAR_DEVICE_LIMIT = 'AUTH_CLEAR_DEVICE_LIMIT';

export const SET_USER_DETAILS = 'SET_USER_DETAILS';

// Pending invitations
export const REMOVE_PENDING_INVITATION = 'REMOVE_PENDING_INVITATION';
